import React from 'react';
import { AppBar, Toolbar } from '@material-ui/core';

import { useStyles } from './style';

import { logoInvoice, logoRC } from '../../images';

const Header = () => {
    const classes = useStyles();

    return (
        <AppBar position="static" color="default" elevation={0} className={classes.appBar}>
            <Toolbar className={classes.toolbar}>
                <img src={logoRC} alt="Logo InvoiceOne" />
                <img src={logoInvoice} alt="Logo InvoiceOne" />
            </Toolbar>
        </AppBar>
    );
}

export default Header;